import { render, staticRenderFns } from "./presidencySchaListComp.vue?vue&type=template&id=b080ab28&scoped=true"
import script from "./presidencySchaListComp.vue?vue&type=script&lang=js"
export * from "./presidencySchaListComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b080ab28",
  null
  
)

export default component.exports